import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-tooltips',
    templateUrl: './tooltips.component.html',
    encapsulation: ViewEncapsulation.None
})
export class TooltipsComponent implements OnInit {
    constructor() { }
    ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/tooltips/tooltips.component.ts